import React from "react";
import moment from "moment";

const PreviousAdviceTableBody = ({ adviceIndex, advice }) => {
  return (
    <tr key={adviceIndex} className="hover:bg-gray-50 transition-colors">
      <td className="px-4 py-4">
        <div className="w-[120px] overflow-auto break-words">
          {advice?.date ? moment(advice?.date).format("Do MMM YYYY") : "-"}
        </div>
      </td>
      <td className="px-4 py-4">
        <div className="w-[200px] overflow-auto break-words">
          {advice?.symbol ? advice?.symbol : "-"}
        </div>
      </td>
      <td className="px-4 py-4">{advice?.type ? advice?.type : "-"}</td>
      <td className="px-4 py-4">
        {" "}
        {advice?.exchange ? advice?.exchange : "-"}
      </td>
      <td className="px-4 py-4">
        {" "}
        {advice?.price_when_send_advice ? advice?.price_when_send_advice : "-"}
      </td>
      <td className="px-4 py-4">
        {" "}
        {advice?.order_type ? advice?.order_type : "-"}
      </td>

      <td className="px-4 py-4">
        {advice?.price !== "0.00" ? advice?.price : "-"}
      </td>
      <td className="px-4 py-4">
        {" "}
        {advice?.product_type ? advice?.product_type : "-"}
      </td>
      <td className="px-4 py-4">{advice?.segment ? advice?.segment : "-"}</td>
      <td className="px-4 py-4  align-top">
        <div className="w-[300px] h-[50px] overflow-auto break-words">
          {advice?.rationale ? advice?.rationale : "-"}
        </div>
      </td>
      <td className="px-4 py-4">
        <div className="w-[300px] h-[50px] overflow-auto break-words">
          {advice?.comments ? advice?.comments : "-"}
        </div>
      </td>
      <td className="px-4 py-4">
        <div className="w-[300px] h-[50px] overflow-auto break-words">
          {advice?.comment2 ? advice?.comment2 : "-"}
        </div>
      </td>
    </tr>
  );
};

export default PreviousAdviceTableBody;
